"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _get_cat_tag_by_id = require("@/api/get_cat_tag_by_id");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { getList } from '@/api/cat_list'
// import { getCat } from '@/api/get_cat_by_id'
// import { getCommonRecord } from '@/api/cat_record'
// import { fileUpload } from '@/api/file_upload'
// import Upload from '@/components/Upload'
// import UploadMultiple from '@/components/Upload/multiple'
var _default = {
  // components: {Upload, UploadMultiple },
  data: function data() {
    var _this = this;

    var validateRequire = function validateRequire(rule, value, callback) {
      if (!value) {
        _this.$message({
          message: rule.name + '都没填就点提交，打你啊！',
          type: 'error'
        });

        callback(new Error(rule.name + '为必传项'));
      } else {
        callback();
      }
    };

    return {
      editTagForm: {
        id: '',
        tag: '',
        intro: ''
      },
      imageUrl: '',
      activeName: 'first',
      catList: null,
      tags: [],
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      editTagFormRules: {
        tag: [{
          required: true,
          name: '“品种名称” ',
          trigger: 'blur',
          validator: validateRequire
        }],
        intro: [{
          required: true,
          name: '“品种介绍” ',
          trigger: 'blur',
          validator: validateRequire
        }]
      }
    };
  },
  created: function created() {
    this.listLoading = true;
    this.editTagForm.id = this.$route.params.id;

    if (this.editTagForm.id % 1 === 0) {
      this.fetchData();
    }
  },
  methods: {
    handleRemove: function handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload: function handleDownload(file) {
      console.log(file);
    },
    fetchData: function fetchData() {
      var _this2 = this;

      (0, _get_cat_tag_by_id.getCatTag)(this.editTagForm.id).then(function (response) {
        var tag = response.data;
        console.log(tag);
        _this2.editTagForm.tag = tag.tag;
        _this2.editTagForm.intro = tag.intro;
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.$refs.editTagForm.validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          var tag = _this3.editTagForm;

          _this3.$store.dispatch('cat_tags/edit', _this3.editTagForm).then(function (data) {
            _this3.$message({
              message: data.msg,
              type: 'success'
            });

            _this3.loading = false;

            _this3.$router.push({
              path: '/cat-base/tags'
            });
          }).catch(function () {
            _this3.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onCancel: function onCancel() {
      this.$message({
        message: 'cancel!',
        type: 'warning'
      });
    },
    handleClick: function handleClick(tab, event) {// console.log(tab, event)
    }
  }
};
exports.default = _default;